import "./About.css";
import AboutHero from "./AboutHero";
import AboutSidebar from "./AboutSidebar";

import Journey1 from "../../utils/images/our-journey/1997.jpg";
import Journey2 from "../../utils/images/our-journey/2004.jpg";
import Journey3 from "../../utils/images/our-journey/2011.jpeg";
import Journey4 from "../../utils/images/our-journey/2018.jpg";
import Journey5 from "../../utils/images/hero2.PNG";

function OurJourney() {
  const timelineData = [
    {
      year: "1997",
      image: Journey1,
      title: "Foundation of IQRAA Public School",
      description:
        "IQRAA Public School was established with a vision to provide quality education and nurture responsible citizens for the future.",
    },
    {
      year: "2004",
      image: Journey2,
      title: "Infrastructure Development",
      description:
        "The school expanded its campus with modern classrooms, improved facilities, and a student-friendly learning environment.",
    },
    {
      year: "2011",
      image: Journey3,
      title: "Academic Excellence",
      description:
        "Introduction of computer education, smart learning tools, and modern laboratory facilities to enhance practical knowledge.",
    },
    {
      year: "2018",
      image: Journey4,
      title: "Infrastructure Renovation",
      description:
        "Recognized for academic achievements, student development, and commitment towards holistic education.",
    },
    {
      year: "2025",
      image: Journey5,
      title: "Shaping the Future of Learning",
      description:
        "Continued focus on innovation, sustainability, and preparing students for the challenges of the future.",
    },
  ];

  return (
    <>
      <AboutHero />

      <section className="about-detail-page">
        <div className="container py-4">
          <div className="row">
            <div className="col-lg-3">
              <AboutSidebar />
            </div>

            <div className="col-lg-9">
              <h2 className="journey-title">Our Journey</h2>

              <div className="timeline">
                {timelineData.map((item, index) => (
                  <div key={index} className="timeline-item">
                    <div className="timeline-year">{item.year}</div>

                    <div className="timeline-card">
                      <img
                        src={item.image}
                        alt={item.title}
                        className="timeline-image"
                      />

                      <h4>{item.title}</h4>

                      <p>{item.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default OurJourney;
